
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-date-pickers/date-time-range-field",
      function () {
        return require("private-next-pages/x/react-date-pickers/date-time-range-field.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-date-pickers/date-time-range-field"])
      });
    }
  